const galleryCards = Array.from(document.querySelectorAll('.gallery-card'));
const lightbox = document.getElementById('gallery-lightbox');
const lightboxImage = lightbox.querySelector('.lightbox-image');
const lightboxClose = lightbox.querySelector('.lightbox-close');
const flashRing = lightbox.querySelector('.flash-ring');
const prevButton = lightbox.querySelector('.lightbox-prev');
const nextButton = lightbox.querySelector('.lightbox-next');
let activeIndex = 0;

const openLightbox = (src, alt) => {
    lightboxImage.src = src;
    lightboxImage.alt = alt;
    lightbox.classList.add('active');
    lightbox.setAttribute('aria-hidden', 'false');
    flashRing.classList.remove('flash-animate');
    void flashRing.offsetWidth;
    flashRing.classList.add('flash-animate');
};

const closeLightbox = () => {
    lightbox.classList.remove('active');
    lightbox.setAttribute('aria-hidden', 'true');
    lightboxImage.src = '';
};

const showImageAt = (index) => {
    activeIndex = (index + galleryCards.length) % galleryCards.length;
    const card = galleryCards[activeIndex];
    const imageSrc = card.dataset.image;
    const imageAlt = card.querySelector('img').alt;
    openLightbox(imageSrc, imageAlt);
};

galleryCards.forEach((card, index) => {
    card.addEventListener('click', () => {
        showImageAt(index);
    });
});

prevButton.addEventListener('click', () => {
    showImageAt(activeIndex - 1);
});

nextButton.addEventListener('click', () => {
    showImageAt(activeIndex + 1);
});

lightboxClose.addEventListener('click', closeLightbox);
lightbox.addEventListener('click', (event) => {
    if (event.target === lightbox || event.target === lightbox.querySelector('.lightbox-backdrop')) {
        closeLightbox();
    }
});

document.addEventListener('keydown', (event) => {
    if (!lightbox.classList.contains('active')) {
        return;
    }

    if (event.key === 'Escape') {
        closeLightbox();
    }

    if (event.key === 'ArrowLeft') {
        showImageAt(activeIndex - 1);
    }

    if (event.key === 'ArrowRight') {
        showImageAt(activeIndex + 1);
    }
});

// Prevent click events from closing lightbox when clicking the image.
lightboxImage.addEventListener('click', (event) => {
    event.stopPropagation();
});
